import React, { ChangeEventHandler } from 'react';
import { Schedule } from '../../../store/locationCostsSlice';
import ValidatorFormGroup from './../../main/validator-form-group';
import useTranslate from '../../useTranslate';

interface Props {
    label: string;
    hint?: string;

    value: Schedule;
    onChange: ChangeEventHandler<HTMLSelectElement>;

    disabled?: boolean;
}

function ScheduleTimeSelect(props: Readonly<Props>) {
    const strings = useTranslate('ScheduleTimeSelect');

    return (
        <ValidatorFormGroup
            label={props.label}
            helpLabel={props.hint}
            hideErrorLabel
        >
            <select
                className={'form-control'}
                name={'schedule_type'}
                onChange={props.onChange}
                value={props.value}
                required
                disabled={props.disabled}
            >
                {Object.values(Schedule).map(renderOption)}
            </select>
        </ValidatorFormGroup>
    );

    function renderOption(schedule: Schedule) {
        return (
            <option key={schedule} value={schedule}>
                {strings[schedule]}
            </option>
        );
    }
}

export default ScheduleTimeSelect;
